module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraBold.01ddfa5.eot";